import { render, staticRenderFns } from "./NuevaArea.vue?vue&type=template&id=49fe1c66&"
import script from "./NuevaArea.vue?vue&type=script&lang=js&"
export * from "./NuevaArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports